module.exports = __webpack_public_path__ + "img/EOS EVM.669e3733.png";